import { ButtonGroup, PrimaryButton, GhostButton } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import type { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { WithPopover } from '@ardoq/popovers';
import { viewpointBuilderTracking } from '../viewpointBuilderTracking';
import { PageBodyFooter } from '@ardoq/page-layout';
import { t, type I18nLocale } from '@ardoq/i18n';

type ViewpointBuilderFooterProps = {
  closeViewpointBuilder: () => void;
  primaryButtonConfig?: PrimaryButtonConfig;
  i18nLocale: I18nLocale;
};

export const ViewpointBuilderFooter = ({
  closeViewpointBuilder,
  primaryButtonConfig,
  i18nLocale,
}: ViewpointBuilderFooterProps) => {
  return (
    <PageBodyFooter>
      <ButtonGroup>
        <GhostButton
          onClick={() => {
            viewpointBuilderTracking.trackCloseViewpointBuilder();
            closeViewpointBuilder();
          }}
        >
          <Icon iconName={IconName.LOG_OUT} />
          {t(
            i18nLocale,
            'viewpointBuilder:footer.cancelAndExit',
            'Cancel & exit'
          )}
        </GhostButton>
        {primaryButtonConfig && (
          <WithPopover
            content={primaryButtonConfig.popoverContentForDisabledItem}
          >
            <PrimaryButton
              dataTestId="viewpoint-builder-primary-cta"
              onClick={() =>
                primaryButtonConfig.primaryAction(closeViewpointBuilder)
              }
              isDisabled={primaryButtonConfig.isDisabled}
            >
              {primaryButtonConfig.primaryButtonLabel}
              <Icon iconName={primaryButtonConfig.iconName} />
            </PrimaryButton>
          </WithPopover>
        )}
      </ButtonGroup>
    </PageBodyFooter>
  );
};
